<template>
  <!-- Update Modal -->
  <b-modal
    :active.sync="localModalStatus"
    scroll="keep"
    class="update-history-modal"
    :full-screen="isFullScreen"
    @close="closeUpdateModal"
  >
    <div class="modal-card update-history">
      <header class="modal-card-head">
        <h2 class="modal-card-title">
          Update history
        </h2>
        <i
          class="fa-2x dark-ben-franklin fas fa-times"
          @click="closeUpdateModal"
        />
      </header>
      <hr>
      <section class="modal-card-body">
        <p>This is a list of changes to this content since it was first posted.</p>
        <p>Published on: {{ publishedDate }}</p>
        <ul>
          <li
            v-for="(update, index) of updateHistory"
            :key="index"
          >
            <span v-html="update.phila_update_date" />.
            <span v-html="philaLink(update.phila_update_information)" />
          </li>
        </ul>
      </section>
    </div>
  </b-modal>
  <!-- /Update Modal -->
</template>


<script>
import moment from 'moment';

export default {
  name: 'UpdateModal',
  props: {
    isUpdateModalOpen: {
      type: Boolean,
      default: false,
    },
    postInfo: {
      type: Object,
      required: true,
    },
    updateHistory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isFullScreen: false,
      localModalStatus: false,
    };
  },
  computed: {
    publishedDate() {
      return moment(this.postInfo.post_date).format('MMMM D, YYYY');
    },
  },
  watch: { 
    isUpdateModalOpen: function(newVal) {
      this.localModalStatus = newVal;
    },
  },
  methods: {
    closeUpdateModal() {
      let vm = this;
      vm.localModalStatus = false;
      vm.$emit('closeUpdateModal');
    },
  },
};
</script>